import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Route, Switch, useHistory } from 'react-router-dom'
import { PublishRounded, Add } from '@mui/icons-material'
import { useStores } from '@trivie/core'
import { TableHelper } from '../../../tables'
import { Header } from '@trivie/ui-web/components/header'
import { TopicsDetailsScreen } from './topics-details-screen'
import { AssignmentCreateDialog } from '../../activities/assignments/create-assignment/assignment-create'
import { TopicTable } from '../../../tables/topic-table'
import { ImportContentDialog } from '../../../components/dialogs/import-content-dialog'

export const TopicsScreen: React.FunctionComponent = observer(() => {
  const { topicsStore, formStore, contentCreationStore, manageUserStore } = useStores()
  const { setTopics } = topicsStore
  const { setFormData } = formStore
  const { resetContentStore } = contentCreationStore
  const { permissions } = manageUserStore

  const [importing, setImporting] = useState(false)
  const [showWizard, setShowWizard] = useState(false)
  const [assignmentTopicIds, setAssignmentTopicIds] = useState<string[] | null>(null)
  const [tableHelper] = useState(new TableHelper('list_topics', 'topics', 'topics'))

  const history = useHistory()

  const handleCreateTopic = () => {
    resetContentStore()
    setFormData(undefined)
    resetContentStore()
    history.push('/content/creation/topic')
  }

  const primary = {
    disabled: !permissions?.permissions.some((p) => p.code === 'can_create_topic'),
    startIcon: <Add />,
    onClick: handleCreateTopic,
    text: 'Create Topic',
  }

  const secondary = {
    disabled: !permissions?.permissions.some((p) => p.code === 'can_create_topic'),
    startIcon: <PublishRounded />,
    onClick: () => {
      resetContentStore()
      setImporting(true)
    },
    text: 'Import Topics',
  }

  return (
    <Switch>
      <Route exact path="/content/topics">
        <Header divider title="Topics" primaryAction={primary} secondaryAction={secondary} />
        <TopicTable tableHelper={tableHelper} />
        {importing && (
          <ImportContentDialog
            intent="Topics"
            title="Import Topics"
            onClose={() => {
              setTopics(null)
              setImporting(false)
            }}
            open={importing}
          />
        )}
        {showWizard && (
          <AssignmentCreateDialog
            fromTopics
            open={showWizard}
            initialTopics={
              assignmentTopicIds ? assignmentTopicIds.map((id) => parseInt(id)) : undefined
            }
            requestClose={() => {
              resetContentStore()
              setShowWizard(false)
              history.push(`/content/topics`)
            }}
          />
        )}
      </Route>
      <Route path="/content/topics/:id/:tab">
        <TopicsDetailsScreen />
      </Route>
    </Switch>
  )
})
